<template>
    <div class="no-record-found">
        <div class="middle-align">
            <div class="no-record-image">
                <no-record-icon></no-record-icon>
            </div>
            <p>No Record Found</p>
        </div>
    </div>
</template>
<script>
import noRecordIcon from '@/components/icons/noRecordIcon.vue'
export default {
    components: {
        noRecordIcon,
    },
    /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
    props: {}, // End of Component > props

    /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
    data() {
        return {}
    }, // End of Component > data

    /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
    computed: {}, // End of Component > methods

    /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
    mounted() {}, // End of Component > computed

    /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
    methods: {}, // End of Component > mounted
} // End of export default
</script>
